var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditoffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52835 3.35059H2.76862C2.40794 3.35059 2.06204 3.49386 1.807 3.7489C1.55197 4.00393 1.40869 4.34984 1.40869 4.71051V14.23C1.40869 14.5907 1.55197 14.9366 1.807 15.1916C2.06204 15.4466 2.40794 15.5899 2.76862 15.5899H12.2881C12.6488 15.5899 12.9947 15.4466 13.2497 15.1916C13.5047 14.9366 13.648 14.5907 13.648 14.23V9.47025",
    stroke: "#E52333",
    strokeWidth: 1.35992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6281 2.33068C12.8986 2.06017 13.2655 1.9082 13.648 1.9082C14.0306 1.9082 14.3974 2.06017 14.668 2.33068C14.9385 2.60118 15.0904 2.96807 15.0904 3.35062C15.0904 3.73317 14.9385 4.10006 14.668 4.37056L8.20831 10.8302L5.48846 11.5102L6.16843 8.79032L12.6281 2.33068Z",
    fill: "#67833E",
    stroke: "#E52333",
    strokeWidth: 1.35992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3191,
    height: 16.3191,
    fill: "white",
    transform: "translate(0.0487671 0.630859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditoffer);
export default __webpack_public_path__ + "static/media/editoffer.37f759a298f8366bc93f5719b5404026.svg";
export { ForwardRef as ReactComponent };